import { User } from 'core/entities';
import { AvailableUserPermission } from 'core/entities/user/user-permissions';
import { FeatureFlagsKeys } from 'core/entities/user/user-feature-flags';

const appcuesPermissionsKeys: AvailableUserPermission[] = [
    'advanced_reports_persona_taxonomy_v5',
    'advanced_reports_persona_taxonomy_v2',
];

const appcuesFeatureFlagsKeys: FeatureFlagsKeys[] = [
    'enable_market_workforce_report',
    'enable_market_visitors_report',
    'enable_pi_in_the_platform',
];

export const appcuesIdentifyUser = (user: User) => {
    if (!window.Appcues) return;

    if (user.settings?.account) {
        window.Appcues.group(user.settings.account.id, {
            id: user.settings.account.id,
            displayName: user.settings.account.display_name,
            is_active: user.settings.account.is_active,
            name: user.settings.account.name,
        });
    }

    const appcuesPermissions = appcuesPermissionsKeys.reduce((acc, flag) => {
        acc[flag] = !!user.permissions?.[flag];
        return acc;
    }, {} as Record<AvailableUserPermission, boolean>);

    const appcuesFeatureFlags = appcuesFeatureFlagsKeys.reduce((acc, flag) => {
        acc[flag] = !!user.featureFlags?.[flag];
        return acc;
    }, {} as Record<FeatureFlagsKeys, boolean>);

    window.Appcues.identify(user.email, {
        name: user.fullName,
        id: user.id,
        device: user.device,
        isNew: user.isNew,
        username: user.username,
        isFreemium: !user.settings?.account?.is_active,
        ...appcuesPermissions,
        ...appcuesFeatureFlags,
    });
};
